'use client';

import Link from 'next/link';
import { Shield, Truck, RotateCcw, Phone, Star, Heart } from 'lucide-react';

export default function HakkimizdaPage() {
  const ozellikler = [
    { icon: Shield, baslik: 'Güvenli Ödeme', aciklama: 'Visa, Mastercard, Havale ve EFT ile güvenli ödeme imkanı' },
    { icon: Truck, baslik: 'Ücretsiz Kargo', aciklama: "Türkiye'nin her yerine tüm alışverişlerde ücretsiz kargo" },
    { icon: RotateCcw, baslik: '7 Gün İade', aciklama: 'Ücretsiz değişim ve iade hakkı, hiçbir soru sormadan' },
    { icon: Phone, baslik: 'Telefonla Sipariş', aciklama: 'Bizi arayarak da kolayca sipariş verebilirsiniz' },
    { icon: Star, baslik: 'Kaliteli Ürünler', aciklama: 'Alanında uzman tedarikçilerden seçilmiş ürün yelpazesi' },
    { icon: Heart, baslik: 'Müşteri Memnuniyeti', aciklama: '"Önce Memnuniyet" vizyonuyla her gün daha iyiye' },
  ];

  return (
    <div className="min-h-screen bg-[var(--color-gray-50)]">

      {/* Hero */}
      <div className="bg-gradient-to-br from-[var(--color-primary)] to-[var(--color-primary-dark)] text-white">
        <div className="max-w-5xl mx-auto px-4 py-10 text-center">
          <div className="text-5xl mb-4">🤸</div>
          <h1 className="text-3xl md:text-4xl font-bold mb-2">Karacaspor</h1>
          <p className="text-base text-blue-100 max-w-2xl mx-auto">
            2018'den bu yana spor ekipmanları alanında güvenilir çözüm ortağınız
          </p>
        </div>
      </div>

      {/* Hakkımızda */}
      <div className="max-w-5xl mx-auto px-4 py-16">
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8 md:p-12 mb-12">
          <h2 className="text-2xl font-bold text-gray-800 mb-4">Biz Kimiz?</h2>
          <p className="text-gray-600 leading-relaxed text-lg">
            Karaca Spor, <strong>2018 yılından</strong> günümüze çeşitli spor ekipmanları tedarikçisi olarak faaliyet gösteren bir spor mağazasıdır. <strong>"Önce Memnuniyet"</strong> vizyonunu benimseyerek, alanında hızla büyümeye devam etmektedir.
          </p>
          <p className="text-gray-600 leading-relaxed mt-4">
            Müşteri memnuniyetini her gün daha iyiye taşımak için çalışıyor, kaliteli ürünleri uygun fiyatlarla sunmayı hedefliyoruz.
          </p>
        </div>

        {/* Neden Biz */}
        <h2 className="text-2xl font-bold text-gray-800 mb-8 text-center">Neden Bizi Tercih Etmelisiniz?</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16">
          {ozellikler.map((o, i) => {
            const Icon = o.icon;
            return (
              <div key={i} className="bg-white rounded-2xl border border-gray-100 p-6 shadow-sm hover:shadow-md transition-shadow">
                <div className="w-12 h-12 bg-blue-50 rounded-xl flex items-center justify-center mb-4">
                  <Icon className="text-[var(--color-primary)]" size={24} />
                </div>
                <h3 className="font-semibold text-gray-800 mb-2">{o.baslik}</h3>
                <p className="text-gray-500 text-sm leading-relaxed">{o.aciklama}</p>
              </div>
            );
          })}
        </div>

        {/* İletişim */}
        <div className="bg-white rounded-2xl border border-gray-100 p-8 md:p-12 shadow-sm">
          <h2 className="text-2xl font-bold text-gray-800 mb-6">Size Nasıl Yardımcı Olabiliriz?</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
            <a href="tel:+905324379608" className="flex items-center gap-4 p-4 bg-blue-50 rounded-xl hover:bg-blue-100 transition">
              <div className="w-10 h-10 bg-[var(--color-primary)] rounded-full flex items-center justify-center flex-shrink-0">
                <Phone className="text-white" size={18} />
              </div>
              <div>
                <p className="text-xs text-gray-500 mb-0.5">Telefon</p>
                <p className="font-semibold text-gray-800">+90 (532) 437 96 08</p>
              </div>
            </a>
            <a href="mailto:info@karacaspormarket.com" className="flex items-center gap-4 p-4 bg-blue-50 rounded-xl hover:bg-blue-100 transition">
              <div className="w-10 h-10 bg-[var(--color-primary)] rounded-full flex items-center justify-center flex-shrink-0">
                <span className="text-white text-sm">@</span>
              </div>
              <div>
                <p className="text-xs text-gray-500 mb-0.5">E-posta</p>
                <p className="font-semibold text-gray-800">info@karacaspormarket.com</p>
              </div>
            </a>
          </div>

          {/* Sosyal Medya */}
          <div>
            <p className="text-gray-600 mb-4">Yeni ürünlerden ve fırsatlardan haberdar olmak için bizi takip edin:</p>
            <div className="flex gap-3">
              <a
                href="https://www.instagram.com/karacaspormarket"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-purple-500 to-pink-500 text-white rounded-lg text-sm font-medium hover:opacity-90 transition"
              >
                <span>📸</span> Instagram
              </a>
              <a
                href="https://www.facebook.com/karacaspormarket"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg text-sm font-medium hover:bg-blue-700 transition"
              >
                <span>👍</span> Facebook
              </a>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <p className="text-gray-500 mb-4 text-lg">Keyifli alışverişler dileriz! 🛍️</p>
          <Link
            href="/"
            className="inline-flex items-center gap-2 bg-[var(--color-primary)] text-white px-8 py-3 rounded-xl font-semibold hover:bg-[var(--color-primary-dark)] transition"
          >
            Alışverişe Başla
          </Link>
        </div>
      </div>
    </div>
  );
}
